import {createApp} from "vue";
import App from "@/vue/ResourceFinder/ResourceFinder.vue";

// App main
const main = async () => {
    // Async load the vue module
    const app = createApp(App)
    app.mount('resource-finder')
};

// Execute async function
main().then(() => {
    console.log('Loaded resource finder');
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}